<!-- 大屏左侧城市分布统计卡片 -->
<template>
    <div class="box">
        <div class="tTitle">
            <div class="fTitleBorderTop"></div>
            城市分布统计
        </div>
        <div class="deviceStatusContent" ref="canva6"></div>
        <div class="menu" @click="changeEchartsType">
            <span>{{ echartsType ? '区县' : '城市' }}</span><span class="iconfont icon-qiehuan"></span>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'leftcard3',
    data() {
        return {
            echartsType: true, // true为区县 false为城市
            echartsDom: null
        };
    },
    mounted() {
        this.cityGeocoder();
    },
    methods: {
        // 切换地图类型
        changeEchartsType() {
            this.echartsType = !this.echartsType;
            // 销毁echarts
            this.echartsDom.dispose();
            this.cityGeocoder();
        },
        async cityGeocoder() {
            let deviceArr = JSON.parse(JSON.stringify(this.$store.state.deviceNowData));
            // 筛选出未设置位置的设备
            let notLocationArr = [];
            let isLocationArr = [];
            deviceArr.forEach((item) => {
                if (!item.latitude || !item.longitude) {
                    notLocationArr.push(item);
                } else {
                    isLocationArr.push(item);
                }
            });
            // 定义城市数组
            let cityArr = [];
            let that = this;
            isLocationArr.forEach(async (item, index) => {
                if (item.city != null && item.county != null) {

                    const result = await this.myGeocoder(item);

                    cityArr.push(result);

                    if (index == isLocationArr.length - 1) {
                        this.cityComputerBar(cityArr);
                    }
                }
            });
        },

        // 天地图地图逆地址解析(取消-修改到数据库)
        async myGeocoder(item) {
            // const result = await axios.get(
            //     `https://api.tianditu.gov.cn/geocoder?postStr={'lon':${latitude},'lat':${longitude},'ver':1}&type=geocode&tk=1bc2a288dc2d3d9b70e69dc1d9ed2a6e`
            // );

            if (this.echartsType) {

                // 区县
                return item.county;
            } else {
                // 城市

                return item.city;
            }
        },

        async cityComputerBar(cityArr) {

            let arr = cityArr;
            let newArr = [...new Set(arr)];
            let lastArr = [];
            newArr.forEach((item) => {
                let num = 0;
                arr.forEach((i) => {
                    if (item == i) {
                        num++;
                    }
                });
                lastArr.push({
                    name: item,
                    num
                });
            });

            // 图表x轴
            let xData = [];
            lastArr.forEach((item) => {
                xData.push(item.name);
            });

            // 图表值
            let searies = [];
            lastArr.forEach((item) => {
                searies.push(item.num);
            });

            this.leftcard(searies, xData);
        },

        leftcard(searies, xData) {
            this.echartsDom = this.$echarts.init(this.$refs.canva6);
            this.echartsDom.setOption({
                grid: {
                    bottom: 20,
                    left: 50
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisLabel: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    show: true,
                    borderColor: '#10a8ff',
                    backgroundColor: '#000',
                    textStyle: {
                        color: '#fff',
                        fontWeight: 'bold'
                    }
                },

                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        color: '#fff'
                    }
                },
                series: [
                    {
                        data: searies,
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'top',
                            color: '#fff'
                        },
                        itemStyle: {
                            color: '#4fb5c9'
                        },
                        barWidth: 16, // 柱条的宽度，不设时自适应。
                        barGap: 200 // 不同系列的柱间距离
                    }
                ]
            });
        }
    }
};
</script>

<style lang="less" scoped>
.box {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;

    .tTitle {
        width: 0.8rem;
        word-wrap: break-word;
        font-size: 0.4rem;
        text-align: center;
        display: flex;
        font-weight: bold;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        padding: 0.1rem;
        border-right: 1px solid #14283e;
        background-color: #000;

        .fTitleBorderTop {
            width: 0.4rem;
            height: 0.1rem;
            background-color: #63b7d8;
        }
    }

    .deviceStatusContent {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding-bottom: 10px;
    }

    .menu {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 99;
        background-color: #000;
        font-size: 0.3rem;
        box-sizing: border-box;
        padding: 0.1rem 0.2rem;
        color: #fff;
        transition: all 0.5s;

        .iconfont {
            font-size: 0.3rem;
            padding-left: 0.1rem;
        }
    }

    .menu:hover {
        background-color: #fff;
        color: #000;
        cursor: pointer;
    }
}
</style>